import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchive: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="archive, folder, box"><path d="M20.255 20.25V8.75H3.75V20.25H20.255Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 8V2.75H10.5L12.5 4.75H18.25V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12.75L11.75 12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArchive;
